import * as React from 'react'
import styled  from 'styled-components'
import Header from './Header'
// Create an style for the component 
const ModalWrapper = styled.section`
width: 100%;
height: 100%;
z-index: 99999;
position: fixed;
background: #fffbf5;
top: 0;
left: 0;
`
 

class Modal extends React.Component {

  render() {
    const {children,onClickIcon}=this.props
    return (
      <ModalWrapper>
        <Header backIcon={true} clickOnBackIcon={()=>onClickIcon()} style={{position:'relative'}}/>
          {children}
      </ModalWrapper>

    )
  }
}

export { Modal }
